import React from 'react'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import getMuiTheme from 'material-ui/styles/getMuiTheme'
import {blue500, blue700} from 'material-ui/styles/colors'

const muiTheme = getMuiTheme({
  palette: {
    primary1Color: blue500,
    primary2Color: blue700,
    pickerHeaderColor: blue500
  },
  fontFamily: 'Roboto, sans-serif'
})

const App = (props) => {
  return (
    <MuiThemeProvider muiTheme={muiTheme}>
      {props.children}
    </MuiThemeProvider>
  )
}

export default App



/** WEBPACK FOOTER **
 ** ./src/components/App.js
 **/